module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"close":"Fechar","copied":"O link de download foi copiado para a área de transferência.","copy":"Copiar","generate-label":"Gerar","generate-placeholder":"Clique em \u0027Gerar\u0027 para obter o(s) arquivo(s)","generating-placeholder":"Arquivo(s) para download sendo gerado(s)...","title":"Arquivos para download","update":"Atualizar"}}')
  delete Component.options._Ctor
}
